<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<TemplateDeleteDialog
					v-if="authority_flag"
					:openBtnColor="'primary'"
					:deleteMethod="deleteProblemCase"
				>
					<template v-slot:btn-text>削除</template>
					<template v-slot:text>
						本当に削除してよろしいですか？<br />削除すると元に戻すことはできません。
					</template>
				</TemplateDeleteDialog>
				<v-btn
					v-if="authority_flag"
					color="white"
					text
					class="ml-2"
					@click="$router.push({ name: 'problem_case_edit', params: { id } })"
				>
					<v-icon class="mr-1">mdi-pencil</v-icon>
					編集
				</v-btn>
			</template>
			<template v-if="$vuetify.breakpoint.xs">
				<v-row no-gutters justify="end">
					<TemplateDeleteDialog
						v-if="authority_flag"
						:openBtnColor="'secondary'"
						:deleteMethod="deleteProblemCase"
					>
						<template v-slot:btn-text>削除</template>
						<template v-slot:text>
							本当に削除してよろしいですか？<br />削除すると元に戻すことはできません。
						</template>
					</TemplateDeleteDialog>
					<v-btn
						v-if="authority_flag"
						color="secondary"
						class="ml-2"
						@click="$router.push({ name: 'problem_case_edit', params: { id } })"
					>
						<v-icon class="mr-1">mdi-pencil</v-icon>
						編集
					</v-btn>
				</v-row>
			</template>

			<v-sheet elevation="0">
				<ProblemCaseShowSection :problem_case="problem_case" />
			</v-sheet>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import TemplateDeleteDialog from "../shared/TemplateDeleteDialog.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import ProblemCaseShowSection from "./components/ProblemCaseShowSection.vue"

export default {
	components: {
		CommonFlame,
		TemplateDeleteDialog,
		PaginationModule,
		ProblemCaseShowSection,
	},
	data() {
		return {
			title: "問題事例詳細",
			id: this.$route.params.id,
			problem_case: {
				user: {
					full_name_: null,
				},
			},
			authority_flag: false,
			common,
		}
	},

	mounted() {
		this.fetchProblemCase()
	},
	methods: {
		fetchProblemCase() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/problem_cases/${this.id}`
			axios
				.get(url, {
					headers,
				})
				.then((response) => {
					this.problem_case = response.data.problem_case
					this.authority_flag = response.data.authority_flag
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		deleteProblemCase() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/problem_cases/${this.id}`
			axios
				.delete(url, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "削除しました。",
					})
					this.$router.push({ name: "problem_case_index" })
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>
